import React, { useEffect, useState, useRef } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactQuill, { Quill } from 'react-quill';
import qs from 'qs';
import axios from '@/utils/axios'

import './styles.css';

const NotesModal = ({notableId, notableType, ownerId, ownerType, buttonClass, buttonText, buttonIcon, modalTitle}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleSave = () => {
    const payload = {body: notes};
    if(ownerId) payload.owner_id = ownerId;
    if(ownerType) payload.owner_type = ownerType;

    axios.put(`/notes/${notableType}/${notableId}.json`, qs.stringify(payload)).then(res => {
      setShow(false)
    });
  }

  useEffect(() => {
    if(show){
      setLoading(true);
      const payload = {};
      if(ownerId) payload.owner_id = ownerId;
      if(ownerType) payload.owner_type = ownerType;
  
      axios.get(`/notes/${notableType}/${notableId}.json`, {params: payload}).then(res => {
        setNotes(res.data.note);
        setLoading(false)
      }).catch(() => setLoading(false));
    }
  }, [show]);

  return (
    <>
      <button type="button" className={buttonClass || "btn btn-primary btn-sm"} onClick={handleShow}>
        {buttonIcon && <i className={buttonIcon}></i>}
        {buttonText}
      </button>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {!!modalTitle ? modalTitle : (
              !!ownerType && ownerType == "Tournament" ? (
                <>Edit Shared Private Notes</>
              ) : (
                <>Edit Notes</>
              )
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!loading ? (
            <i className="fa fa-spinner-third fa-spin"></i>
          ) : (
            <ReactQuill theme="snow" value={notes} onChange={setNotes} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NotesModal;